import * as React from 'react'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

const TransactionReconciliationViewChunk = React.lazy(() =>
  import('../feature-sets/TransactionReconciliationView').then(
    ({ TransactionReconciliationView }) => ({
      default: TransactionReconciliationView,
    })
  )
)

export const TransactionReconciliationPage = () => {
  const intl = useProcurifyIntl()

  return (
    <Page
      pageTitle={`Procurify | ${intl.formatMessage(messages.transactionReconciliationPageTitle)}`}
      breadcrumbs={[
        {
          name: intl.formatMessage(messages.transactionReconciliationPageTitle),
        },
      ]}
    >
      <TransactionReconciliationViewChunk />
    </Page>
  )
}
